import {adminRoutes} from '../../../AppRouter/routes';

export const ADMIN_LINKS = [
    {
        route: adminRoutes.users,
        title: 'Manage Users',
    },
    {
        route: adminRoutes.roles,
        title: 'Manage Roles',
    },
    {
        route: adminRoutes.ingestConfigs,
        title: 'Manage Ingest Configs',
    },
    {
        route: adminRoutes.contentPartners,
        title: 'Manage Content Partners',
    },
];
